<template>
	<div class="page">
		<div class="moneyLine">
			<div class="text" style="font-weight: bold;">关联活体订单</div>
			<el-button class="posi" size="mini" type="warning" @click="$router.back()">返回</el-button>
		</div>
		<div class="orderLine">
			<div class="L">
				<div class="nav" style="padding:10px 10px;">
					<span style="padding-left:10px;font-size: 14px;line-height: 28px;">门店:</span>
					<el-select style="width: 150px;" v-model="shopId" placeholder="请选择" size='mini' @change="changeShopId">
						<el-option v-for="item in [{shop_name:'全部',shop_id:''}].concat(shopList)" :key='item.shop_id' :label="item.shop_name" :value="item.shop_id">
						</el-option>
					</el-select>
				</div>
				<div class="tabBox">
					<div class="tabTit">
						<div class="colTit" style="width:120%">门店</div>
						<div class="colTit" style="width:120%">单号</div>
						<div class="colTit">时间</div>
						<div class="colTit">金额</div>
						<div class="colTit" style="width:50%;">操作</div>
					</div>
					<div v-if="orderList.length===0" style="text-align: center;line-height: 400px;;">
						无数据
					</div>
					<div v-else class="tabCon">
						<div class="tabItem" v-for="(item,index) in orderList" :key="index">
							<div class="colItem" style="width:120%">{{item.shopName}}</div>
							<div class="colItem" style="width:120%">{{item.orderNo}}</div>
							<div class="colItem">{{$public.FTime(item.time,'YYYY-MM-DD')}}</div>
							<div class="colItem" >{{item.amount}}</div>
							<div class="colItem" style="width:50%;cursor: pointer;color:#F5882A;" @click="getOrderDetail(item.orderNo)">查看</div>
						</div>
					</div>
				</div>
			</div>
			<div class="R">
				<div class="detail">
					<el-row>
						<el-col :span="8">
							<span class="label">订单编号：</span>{{curOrderDetail.no||'--'}}
						</el-col>
						<el-col :span="8">
							<span class="label">顾客：</span>{{curOrderDetail.nick_name||'--'}}
						</el-col>
						<el-col :span="8">
							<span class="label">电话：</span>{{curOrderDetail.user_mobile||'--'}}
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="8">
							<span class="label">订单类型：</span>{{curOrderDetail.order_type||'--'}}
						</el-col>
						<el-col :span="8" v-if="curOrderDetail.no.split('_')[0]==='CZ'">
							<span class="label">充值活动：</span>{{curOrderDetail.rechargeActivity||'--'}}
						</el-col>
						<el-col :span="8">
							<span class="label">订单状态：</span>{{curOrderDetail.state||'--'}}
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="8">
							<span class="label">总计：</span>{{curOrderDetail.total_price}}
						</el-col>
						<el-col :span="8">
							<span class="label">优惠券：</span>{{curOrderDetail.coupon_list[0]?curOrderDetail.coupon_list[0].name:''}}
						</el-col>
						<el-col :span="8" style="overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">
							<span class="label">订单备注：</span>
							<el-tooltip effect="dark" :content="curOrderDetail.orderRemark+''" placement="left">
								<span>{{curOrderDetail.orderRemark}}</span>
							</el-tooltip>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="8">
							<span class="label">创建人：</span>{{curOrderDetail.create_manager_name}}
						</el-col>
						<el-col :span="8">
							<span class="label">创建时间：</span>{{$public.FTime(curOrderDetail.create_time)}}
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="8">
							<span class="label">结算方式：</span>
							<span style="padding-right: 30px;" v-for="(item,index) in curOrderDetail.pay_info.pay_list" :key="index">
								<span style="padding-right: 2px;">
									{{$public.formatPayTypeState(item.pay_type)}}
								</span>
								{{item.money}}
							</span>
						</el-col>
						<el-col :span="8">
							<span class="label">结算时间：</span>{{$public.FTime(curOrderDetail.pay_info.pay_time)}}
						</el-col>
						<el-col :span="8" style="overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">
							<span class="label">结算备注：</span>
							<el-tooltip effect="dark" :content="curOrderDetail.pay_info.pay_remark+''" placement="left">
								<span>{{curOrderDetail.pay_info.pay_remark}}</span>
							</el-tooltip>
						</el-col>
					</el-row>
				</div>
				<div class="tabBox">
					<div class="tabTit">
						<div class="colTit" >商品名称</div>
						<div class="colTit" >规格</div>
						<div class="colTit">业绩金额</div>
						<div class="colTit">销售人员</div>
					</div>
					<div v-if="orderList.length===0" style="text-align: center;line-height: 400px;">
						无数据
					</div>
					<div v-else class="tabCon">
						<div class="tabItem" v-for="(item,index) in curOrderDetail.order_item_list" :key="index">
							<div class="colItem" >
								<el-tooltip effect="dark" :content="item.goods_name+''" placement="left">
									<span>{{item.goods_name}}</span>
								</el-tooltip>
							</div>
							<div class="colItem" >
								<el-tooltip effect="dark" :content="item.sku_value+''" placement="left">
									<span>{{item.sku_value}}</span>
								</el-tooltip>
							</div>
							<div class="colItem">{{item.price}}</div>
							<div class="colItem">
								<span v-for="(sale,saleIndex) in item.sales_list" :key="saleIndex">
									{{sale.sales_name}}
								</span>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				shopId:'',
				shopList:[],
				
				orderList:[],
				curOrderDetail:{
					no:'',
					nick_name:'',
					user_mobile:'',
					order_type:'',
					state:'',
					total_price:'',
					coupon_list:'',
					orderRemark:'',
					create_manager_name:'',
					create_time:'',
					pay_info:{
						pay_list:[]
					},
					rechargeActivity:'', // 充值活动
				},
			}
		},
		created(){
			this.shopList = this.$store.getters['shopList'];
		},
		mounted() {
			this.orderList = JSON.parse(sessionStorage.getItem('huotiStatisticsOrderList'))
			this.getOrderDetail(this.orderList[0].orderNo)
		},
		methods: {
			changeShopId(){
				let arr = []
				let orderList = JSON.parse(sessionStorage.getItem('huotiStatisticsOrderList'))
				if(this.shopId===''){
					arr = orderList
				}else{
					for(let i=0;i<orderList.length;i++){
						if(orderList[i].shopId === this.shopId){
							arr.push(orderList[i])
						}
					}
				}
				this.orderList = arr;
				if(this.orderList.length>0){
					this.getOrderDetail(this.orderList[0].orderNo)
				}else{
					this.curOrderDetail={
						no:'',
						nick_name:'',
						user_mobile:'',
						order_type:'',
						state:'',
						total_price:'',
						coupon_list:'',
						orderRemark:'',
						create_manager_name:'',
						create_time:'',
						pay_info:{
							pay_list:[]
						},
						rechargeActivity:'', // 充值活动
					}
				}
			},
			getOrderDetail(no){
				let params = {
					orderid: no
				}
				let loading = this.$loading()
				this.$http.get('/api/Order/GetOrder', params).then(res => {
					loading.close()
					if (res.code == 0) {
						let d = res.data;
						this.curOrderDetail.no = d.no;
						this.curOrderDetail.nick_name = d.user_info.nick_name;
						this.curOrderDetail.user_mobile = d.user_info.user_mobile;
						this.curOrderDetail.order_type = d.order_type;
						this.curOrderDetail.state = this.$public.formatOrderState(d.state);
						this.curOrderDetail.total_price = d.total_price;
						this.curOrderDetail.coupon_list = d.coupon_list;
						this.curOrderDetail.orderRemark = d.remark;
						this.curOrderDetail.create_manager_name = d.create_manager_name;
						this.curOrderDetail.create_time = d.create_time;
						this.curOrderDetail.pay_info = d.pay_info;
						this.curOrderDetail.order_item_list = d.order_item_list;
					}
				})
			},
		},
		
	}
</script>

<style lang="scss" scoped="scoped">
	.page {
		height: 100%;
		.moneyLine{
			background-color: #fff;display: flex;height: 52px;background-color: #fff;line-height: 52px;padding: 0 15px;position: relative;
			.text{
				font-size: 14px;color:#333;margin-right: 50px;
			}
			.posi{
				position: absolute;right: 10px;top: 12px;
			}
		}
		.orderLine{
			margin-top:5px;display: flex;height: calc(100% - 60px);
			.L{
				width:607px;margin-right: 10px;flex-shrink: 0;height: 100%;
				.nav{
					display: flex;background-color: #fff;margin-bottom:5px;
					.navItem{
						font-size: 14px;color:#333333;box-sizing: border-box;margin:0 20px;line-height: 44px;cursor: pointer;
						&.active{
							border-bottom:2px solid $mainColor;
						}
					}
				}
				.tabBox{
					padding-bottom:10px;background-color: #fff;height: calc(100% - 51px);box-sizing: border-box;
					.tabTit{
						background-color: $tableTitBg;display: flex;height: 44px;color:#333333;position: relative;justify-content: space-around;
						.colTit{
							line-height: 44px;padding:0 10px;font-size: 14px;width:100%;
						}
						.see{
							position: absolute;right: 0px;padding-right: 20px;color:#467EFF;flex-grow:0;cursor: pointer;
						}
					}
					.tabCon{
						height: calc(100% - 50px);overflow: auto;
						.tabItem{
							background-color: #fff;display: flex;height: 44px;border-bottom:1px solid #f2f2f2;color:#333333;justify-content: space-around;
							.colItem{
								line-height: 44px;padding:0 10px;font-size: 12px;width:100%;
							}
						}
					}
					
				}
			}
			.R{
				width:100%;height: 100%;
				.detail{
					padding:10px;background-color: #fff;font-size: 12px;color:#666;line-height: 35px;width:100%;box-sizing: border-box;
					.label{
						display: inline-block;width:60px;text-align: right;
					}
				}
				.tabBox{
					padding-bottom:46px;background-color: #fff;width:100%;height: calc(100% - 194px);box-sizing: border-box;position: relative;
					.tabTit{
						background-color: $tableTitBg;display: flex;height: 44px;color:#333333;position: relative;justify-content: space-around;padding:0 10px;
						.colTit{
							line-height: 44px;font-size: 14px;width:100%;
						}
						.see{
							position: absolute;right: 0px;padding-right: 20px;color:#467EFF;flex-grow:0;cursor: pointer;
						}
					}
					.tabCon{
						height: calc(100% - 44px);overflow: auto;
						.tabItem{
							background-color: #fff;display: flex;height: 44px;border-bottom:1px solid #f2f2f2;color:#333333;justify-content: space-around;padding:0 10px;
							.colItem{
								line-height: 44px;font-size: 12px;width:100%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;
							}
						}
					}
					.tabPosi{
						position: absolute;display: flex;justify-content: space-between;width:100%;padding:0 12px;line-height: 44px;font-size: 14px;color:#333;box-sizing: border-box;box-shadow: 0px -1px 5px 0px rgba(211, 233, 255, 0.65);
						.tabPosiL{
							
						}
						.tabPosiR{
							
						}
					}
				}
			}
		}
	}
</style>
